"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _blocks = require("@wordpress/blocks");

/**
 * WordPress dependencies
 */
const transforms = {
  from: [{
    type: 'block',
    blocks: ['core/pullquote'],
    transform: _ref => {
      let {
        value,
        citation,
        anchor,
        fontSize,
        style
      } = _ref;
      return (0, _blocks.createBlock)('core/quote', {
        citation,
        anchor,
        fontSize,
        style
      }, (0, _blocks.parseWithAttributeSchema)(value, {
        type: 'array',
        source: 'query',
        selector: 'p',
        query: {
          content: {
            type: 'string',
            source: 'html'
          }
        }
      }).map(_ref2 => {
        let {
          content
        } = _ref2;
        return (0, _blocks.createBlock)('core/paragraph', {
          content
        });
      }));
    }
  }, {
    type: 'block',
    blocks: ['core/group'],
    transform: (_ref3, innerBlocks) => {
      let {
        anchor
      } = _ref3;
      return (0, _blocks.createBlock)('core/quote', {
        anchor
      }, innerBlocks);
    }
  }, {
    type: 'prefix',
    prefix: '>',
    transform: content => (0, _blocks.createBlock)('core/quote', {}, [(0, _blocks.createBlock)('core/paragraph', {
      content
    })])
  }, {
    type: 'raw',
    schema: () => ({
      blockquote: {
        children: '*'
      }
    }),
    selector: 'blockquote',
    transform: node => {
      return (0, _blocks.createBlock)('core/quote', // Don't try to parse any `cite` out of this content.
      // * There may be more than one cite.
      // * There may be more attribution text than just the cite.
      // * If the cite is nested in the quoted text, it's wrong to
      //   remove it.
      {}, (0, _blocks.rawHandler)({
        HTML: node.innerHTML,
        mode: 'BLOCKS'
      }));
    }
  }, {
    type: 'block',
    isMultiBlock: true,
    blocks: ['*'],
    isMatch: (_ref4, blocks) => {
      let {} = _ref4;
      return !blocks.some(_ref5 => {
        let {
          name
        } = _ref5;
        return name === 'core/quote';
      });
    },
    __experimentalConvert: blocks => (0, _blocks.createBlock)('core/quote', {}, blocks.map(block => (0, _blocks.createBlock)(block.name, block.attributes, block.innerBlocks)))
  }],
  to: [{
    type: 'block',
    blocks: ['core/pullquote'],
    isMatch: (_ref6, block) => {
      let {} = _ref6;
      return block.innerBlocks.every(_ref7 => {
        let {
          name
        } = _ref7;
        return name === 'core/paragraph';
      });
    },
    transform: (_ref8, innerBlocks) => {
      let {
        citation,
        anchor,
        fontSize,
        style
      } = _ref8;
      return (0, _blocks.createBlock)('core/pullquote', {
        value: (0, _blocks.serialize)(innerBlocks),
        citation,
        anchor,
        fontSize,
        style
      });
    }
  }, {
    type: 'block',
    blocks: ['core/group'],
    transform: (_ref9, innerBlocks) => {
      let {
        citation,
        anchor
      } = _ref9;
      return (0, _blocks.createBlock)('core/group', {
        anchor
      }, citation ? [...innerBlocks, (0, _blocks.createBlock)('core/paragraph', {
        content: citation
      })] : innerBlocks);
    }
  }, {
    type: 'block',
    blocks: ['*'],
    transform: (_ref10, innerBlocks) => {
      let {
        citation
      } = _ref10;
      return citation ? [...innerBlocks, (0, _blocks.createBlock)('core/paragraph', {
        content: citation
      })] : innerBlocks;
    }
  }]
};
var _default = transforms;
exports.default = _default;
//# sourceMappingURL=transforms.js.map